import React from "react";
import RankingReportCell from "../rankingReportCell/rankingReportCell";
import _ from "lodash";
import { RankingReportElement, RankingReportEntity } from "motivationCard/service/api/models";
import EntitiesReportTable from "shared/reports/components/reportsTable/EntitiesReportTable";
import { IReportElement, ITenantTableColumn } from "shared/reports/models/models";

interface RankingReportsTableV2Props {
    reports: RankingReportEntity[];
    tenantTableColumns: ITenantTableColumn[];
}

const RankingReportsTableV2: React.FC<RankingReportsTableV2Props> = (props: RankingReportsTableV2Props) => {
    const renderReportElement = (reportElement: IReportElement | undefined) => {
        const rankingElement = reportElement as RankingReportElement;
        return rankingElement ? (
            <RankingReportCell
                rank={rankingElement.position ?? 0}
                change={rankingElement.positionDelta ?? 0}
                planTarget={rankingElement.planTarget}
                numberOfCompetitors={rankingElement.groupCount}
                planValue={rankingElement.planValue}
                unit={rankingElement.unitType}
            />
        ) : (
            <></>
        );
    };

    return (
        <EntitiesReportTable
            reportsEntities={props.reports}
            tenantTableColumns={props.tenantTableColumns}
            renderReportElement={renderReportElement}
        />
    );
};

export default RankingReportsTableV2;
